import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { assets } from "../../data/sep26Data";
import { EASE_OUT } from "./hooks";

export const Anterior26 = () => (
  <section data-testid="s26-anterior" className="section-pad">
    <div className="wrap">
      <motion.div
        className="relative isolate overflow-hidden border p-8 sm:p-14"
        style={{ borderColor: "var(--line)" }}
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE_OUT }}
      >
        <img
          src={assets.smoke}
          alt=""
          className="absolute inset-0 -z-10 h-full w-full object-cover opacity-50"
          loading="lazy"
        />
        <div className="absolute inset-0 -z-10" style={{ background: "linear-gradient(90deg, var(--ink) 15%, rgba(7,10,28,.35))" }} />
        <p className="label" style={{ color: "var(--gold)" }}>Archivo</p>
        <h2 className="display mt-3 text-[clamp(40px,6vw,88px)]">Temporada<br />agosto 2026</h2>
        <p className="serif mt-4 max-w-[34ch] text-xl" style={{ color: "var(--muted)" }}>
          Resultados, tabla, goleadores y la galería del campeonato anterior siguen aquí.
        </p>
        <Link to="/temporadaAgosto26" className="btn mt-8" data-testid="s26-ver-anterior">
          Ver temporada anterior <ArrowRight size={18} aria-hidden="true" />
        </Link>
      </motion.div>
    </div>
  </section>
);
